import { CrossIcon } from "shared/ui/Icons";
import styles from "./TagList.module.scss";

type TagListProps = {
  tags: Array<string>;
  deleteTag: (tag: string) => void;
};

export const TagList: RFC<TagListProps> = ({ tags, deleteTag }) => {
  return (
    <span className={styles.tagList}>
      {tags.map((tag) => (
        <span key={tag} className={styles.tag}>
          <span className={styles.title}>{tag}</span>
          <CrossIcon
            className={styles.ico}
            onClick={() => {
              deleteTag(tag);
            }}
          />
        </span>
      ))}
    </span>
  );
};
